/** When automatic top-up's threshold is larger than the pack it would buy. */
export const autoTopUpThresholdExceedsPackMessage =
  "Threshold must be less than the purchased pack!" as const;

export const enterThresholdMessage = "Enter a threshold." as const;

/**
 * The box a UK, EU, or EEA buyer ticks before they buy reads "I agree to the Terms of Service and",
 * then one of these. Asking for what they buy right away, and accepting that they then can't
 * cancel it, ends the 14-day right to cancel that they have for digital content.
 */
export const cancellationWaivers = {
  pack: "ask for my credits right away. I understand I then can't cancel this purchase for a refund.",
  plan: "ask for my plan to start right away. I understand I then can't cancel this purchase for a refund, but I can stop it renewing anytime.",
  auto_top_up:
    "ask for each automatic top-up's credits right away. I understand I then can't cancel an automatic top-up for a refund.",
} as const;
export type WaivedPurchase = keyof typeof cancellationWaivers;
